//NODE
import 'bootstrap';
import 'slick-carousel';

//GLOBAl LIBRARIES
import isotope from './libs/isotope.js';
import slickFunctions from './custom/slickFunctions.js';